import { render, staticRenderFns } from "./PopDown.vue?vue&type=template&id=2f477ed7&"
import script from "./PopDown.vue?vue&type=script&lang=js&"
export * from "./PopDown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports